import styled from 'styled-components';
import tw from 'twin.macro';
import resolveConfig from 'tailwindcss/resolveConfig';

import tailwindConfig from '../../tailwind.config';

const fullConfig = resolveConfig(tailwindConfig);

export type MovieCardStyledProps = {
  isSlider: boolean;
};

export const MovieCardStyled = styled.div<MovieCardStyledProps>`
  ${tw`text-white flex flex-col`}
  /* min-width: 226px; */
  max-width: 312px;
  width: ${(props) => (props.isSlider ? '70%' : '100%')};

  @media (min-width: ${fullConfig.theme.screens.md}) {
    margin-right: 64px;
  }

  .flickity-slider & {
    min-height: 100%;
  }

  .movie-poster {
    ${tw`mb-4 relative flex`}

    img {
      ${tw`absolute`}
    }

    a.movie-poster-link {
      ${tw`absolute w-full h-full flex z-10`}
    }
  }

  h4 {
    ${tw`text-white text-xl font-bold`}
  }

  ul {
    ${tw`flex mt-1 flex-grow sm:flex-row`};
    li {
      ${tw`text-xs sm:text-base text-white text-gray-200 font-normal mb-5 pr-3 flex items-start self-center sm:self-start`};

      &:before {
        ${tw` bg-gray-200 rounded-full h-1 w-1 mr-3 mt-3 hidden sm:visible`};
        width: 3px;
        height: 3px;
        content: '';
      }

      &:first-child {
        &:before {
          display: none;
        }
      }
    }
  }

  .button-groupe {
    ${tw`flex flex-col md:flex-row`}

    .btn {
      &:not(:first-child) {
        ${tw`mt-3 md:ml-3 md:mt-0`}
      }
    }
  }
`;

export const MoviePosterStyled = styled.div`
  ${tw`flex w-full bg-cover rounded-sm bg-no-repeat bg-center justify-center`};
  padding-bottom: 150%;
`;

export const ComingSoonTextStyled = styled.div`
  ${tw`flex justify-start`};

  div {
    margin-bottom: 10px;
  }

  span {
    ${tw`py-1 px-2 pr-2 whitespace-nowrap text-xs capitalize relative`};
    ${tw`text-white bg-blue-100 `};
    background-color: #607d8b;
    font-size: 12px;
    z-index: 1;
    position: relative;
    top: -12px;

    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 0px;
      right: -12px;
      width: 0;
      height: 0;
      border-top: 13px solid #607d8b;
      border-right: 13px solid transparent;
    }

    &:after {
      display: block;
      content: '';
      position: absolute;
      bottom: 0px;
      right: -12px;
      width: 0;
      height: 0;
      border-bottom: 13px solid #607d8b;
      border-right: 13px solid transparent;
    }
  }
`;
